import {
  VStack,
  Text,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Flex,
  Button,
} from "@chakra-ui/react";
import { useState } from "react";

interface CreateListFormProps {
  listType: "comics" | "releases";
  onCreateList: (listData: { name: string; description?: string }) => void;
  onCancel: () => void;
  isCreating: boolean;
}

export function CreateListForm({
  listType,
  onCreateList,
  onCancel,
  isCreating,
}: CreateListFormProps) {
  const [newListName, setNewListName] = useState("");
  const [newListDescription, setNewListDescription] = useState("");

  const handleCreate = () => {
    if (newListName.trim()) {
      onCreateList({
        name: newListName.trim(),
        description: newListDescription.trim() || undefined,
      });
    }
  };

  const handleCancel = () => {
    setNewListName("");
    setNewListDescription("");
    onCancel();
  };

  return (
    <VStack spacing={4} p={4} align="stretch" width="400px">
      <Text fontSize="md" fontWeight="600" color="neutral.200">
        Create New {listType === "comics" ? "Comic" : "Release"} List
      </Text>
      <FormControl isRequired>
        <FormLabel fontSize="sm" color="neutral.400">
          List Name
        </FormLabel>
        <Input
          value={newListName}
          onChange={(e) => setNewListName(e.target.value)}
          placeholder="Enter list name..."
          bg="transparent.white.10"
          border="1px solid"
          borderColor="transparent.white.20"
          color="neutral.200"
          _placeholder={{ color: "neutral.500" }}
          _focus={{
            borderColor: "blaze.300",
            bg: "transparent.white.20",
          }}
          autoFocus
        />
      </FormControl>
      <FormControl>
        <FormLabel fontSize="sm" color="neutral.400">
          Description (Optional)
        </FormLabel>
        <Textarea
          value={newListDescription}
          onChange={(e) => setNewListDescription(e.target.value)}
          placeholder="Enter description..."
          bg="transparent.white.10"
          border="1px solid"
          borderColor="transparent.white.20"
          color="neutral.200"
          _placeholder={{ color: "neutral.500" }}
          _focus={{
            borderColor: "blaze.300",
            bg: "transparent.white.20",
          }}
          resize="vertical"
          minH="80px"
        />
      </FormControl>
      <Flex gap={2} justify="flex-end">
        <Button
          variant="secondary"
          size="sm"
          onClick={handleCancel}
          isDisabled={isCreating}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          size="sm"
          onClick={handleCreate}
          isDisabled={!newListName.trim() || isCreating}
          isLoading={isCreating}
        >
          Create List
        </Button>
      </Flex>
    </VStack>
  );
}
